/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IEcommHeroBanner contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum contentAlignment {
    left = 'left',
    right = 'right'
}

export interface IEcommHeroBannerConfig extends Msdyn365.IModuleConfig {
    title?: Msdyn365.RichText;
    description?: Msdyn365.RichText;
    firstButtonText?: string;
    firstLinkUrl?: Msdyn365.ILinkData;
    firstAnchorTargetID?: string;
    secondButtonText?: string;
    secondLinkUrl?: Msdyn365.ILinkData;
    secondAnchorTargetID?: string;
    bannerImage: Msdyn365.IImageData;
    contentAlignment?: contentAlignment;
    enablePrimaryColour?: boolean;
    isMainMobileBanner?: boolean;
    mobileTitle?: string;
    mobileCaption?: string;
    mobileLink?: boolean;
}

export interface IEcommHeroBannerProps<T> extends Msdyn365.IModule<T> {
    config: IEcommHeroBannerConfig;
}
